import {createApi} from '@reduxjs/toolkit/query/react';

import {axiosBaseQuery} from '../base-query';

export interface IGetStatisticsConfirmedRequest {
    entityName?: string;
    params?: Record<string, any>;
}

export const AppControlProceduresResultApi = createApi({
    reducerPath: 'appControlProceduresResult',
    baseQuery: axiosBaseQuery(),
    tagTypes: ['AppStatisticsConfirmed'],
    endpoints: builder => ({
        getIsAppStatisticsConfirmed: builder.query<any, IGetStatisticsConfirmedRequest>({
            query: ({entityName, params}) => ({
                url: `${entityName}/is-statistics-confirmed`,
                method: 'GET',
                params,
            }),
            providesTags: ['AppStatisticsConfirmed'],
        }),
        getAppStatisticsConfirmed: builder.query<any, IGetStatisticsConfirmedRequest>({
            query: ({entityName, params}) => ({
                url: `${entityName}/confirmation`,
                method: 'GET',
                params,
            }),
        }),
    }),
});

export const {
    useGetIsAppStatisticsConfirmedQuery,
    useLazyGetAppStatisticsConfirmedQuery,
} = AppControlProceduresResultApi;
